export default __webpack_public_path__ + "static/media/death_banner.8a6797ce.jpg";